import { IReportEmbedConfiguration, models } from 'powerbi-client';

export const DAIRYNEXT_WORKSPACE_ID = '32974ad0-ed37-4bca-8568-4132a8c11a1f';

export const DAIRYNEXT_REPORT_IDS = {
  HOMEPAGE: '626691ec-1bef-48d8-8964-caa39bf5c58b',
  ECONOMY: '1177169a-3a0a-439f-9621-c6cf7808b910',
  SUSTAINABILTY: 'ec4c842a-ff5d-4c8a-a5f6-9d60d5d8e9e8',
  CO2_YOUR_DELIVERIES: '736ecf64-dd35-4c4e-94ce-f8a17e4563d0',
  CO2_EXAMPLE_COMPANY: '8b4fcd06-d04e-47c0-8920-f79131bc5bec',
  RATIONS: '0f845361-e9b9-45c6-be24-f5914291534a',
  SILAGE_RESULTS: '06604d53-918d-4d31-ad5e-21047b1f3fc2',
  DAIRY_OVERVIEW: '30503512-848f-4ee0-9cf1-6a6503adb59d',
};

export const SINGLE_PAGE_POWERBI_CONFIG: IReportEmbedConfiguration = {
  type: 'report',
  embedUrl: undefined,
  tokenType: models.TokenType.Embed,
  accessToken: undefined,
  settings: {
    navContentPaneEnabled: false,
    panes: {
      filters: {
        expanded: false,
        visible: false,
      },
    },
  },
};
